/**
 * Description: evaluation接口
 * Author: yangqs
 * Date: 2020-04-26
 * Time: 16:54
 */

export const visitorApi = {
    //埋点日志
    burial_site_log: '/stat/v1',

}
